import React from 'react';
import { Form, Input, Button } from 'antd';

let TransactionSearchForm = (props) => {
    const { form  } = props;
    const { getFieldDecorator } = form;
    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
			if (err) return;
            props.onSubmit(form.getFieldsValue());
        });
    };


    return (
        <Form onSubmit={onSubmit}>
            {getFieldDecorator("merchant_id", {
                initialValue: props.merchant_id,
            })(<Input autoComplete='off' hidden />)}
            <Form.Item label="Virtual UPI handle">
                {getFieldDecorator("VPA", {
                    rules: [
                        { required: true, message: "Please enter a UPI Handle" },
                        { pattern: '^([A-Za-z0-9_\\-\\.])+\\@([A-Za-z])+$', message: "Please enter a valid UPI Handle" },
                    ]
                })((<Input autoComplete='off'/>))}
            </Form.Item>
            <Form.Item label="Unique Transaction Reference">
                {getFieldDecorator("UTR", {
                    rules: [
                        { required: true, message: "Please enter UTR" },
                        { pattern: '^[0-9]{12}$', message: "Please enter a valid 12 digit UTR" },
                    ]
                })((<Input autoComplete='off'/>))}
            </Form.Item>
            <Form.Item label="Amount">
                {getFieldDecorator("amount", {
                    rules: [
                        { pattern: '^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$', message: "Please enter a valid Amount" },
                    ]
                })((<Input autoComplete='off' prefix={<span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />} />))}
            </Form.Item>
            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" htmlType="submit" loading={props.loading}>Search </Button>
            </div>
        </Form>
    )
};

TransactionSearchForm = Form.create()(TransactionSearchForm);
export { TransactionSearchForm };